import React, { useEffect, useState } from 'react'
import { useOutletsQuery } from '../../Store/Apis/outletApi';
import { useSelector } from 'react-redux';
import { isDropdownPermission } from '../../Hooks/permissionsMiddleware';

const AddEditSupplierCategory = ({ handleSubmit, cancel, data }) => {
    console.log(data)
    const user = useSelector((state) => state.auth.user);
    const getOutletApi = useOutletsQuery();
    const [form, setForm] = useState({
        outlet: '',
        categoryName: ''
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (data) {
            setForm({
                outlet: data.outletId || '',
                categoryName: data.categoryName || ''
            });
        }
    }, [data]);

    useEffect(() => {
      if(!isDropdownPermission(user.role_Id) && !data){
        setForm({
            ...form,
            outlet: user.outletID
        })
      }
    }, [])
    
    
    const validate = () => {
        const newErrors = {};
        if (!form.outlet) newErrors.outlet = 'Outlet is required';
        if (!form.categoryName) newErrors.categoryName = 'Category Name is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prevForm) => ({ ...prevForm, [name]: value }));
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            handleSubmit({...form, id: data?.id});
        }
    };

    return (
        <form onSubmit={handleFormSubmit} noValidate>
            <div className="row">
                <div className="col-md-6">
                    <div className="mb-3">
                        <label>Outlet</label>
                        <select
                            name="outlet"
                            className={`form-select ${errors.outlet ? 'is-invalid' : ''}`}
                            value={form.outlet}
                            onChange={handleChange}
                            disabled={!getOutletApi.isSuccess || !isDropdownPermission(user.role_Id)}
                        >
                            <option value="">Select Outlet</option>
                            {getOutletApi?.data?.data.map((outlet) => (
                                <option key={outlet.outletId} value={outlet.outletId}>
                                    {outlet.outletName}
                                </option>
                            ))}
                        </select>
                        {errors.outlet && <small className="text-danger">{errors.outlet}</small>}
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="mb-3">
                        <label>Category Name <span className="text-danger">*</span></label>
                        <input
                            type="text"
                            name="categoryName"
                            className={`form-control ${errors.categoryName ? 'is-invalid' : ''}`}
                            value={form.categoryName}
                            onChange={handleChange}
                            placeholder="Enter Category Name"
                        />
                        {errors.categoryName && <small className="text-danger">{errors.categoryName}</small>}
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-center mt-4">
                <button type="button" className="btn btn-secondary me-2" onClick={()=>cancel(1)}>Cancel</button>
                <button type="submit" className="btn btn-primary">Submit</button>
            </div>
        </form>
    );
};

export default AddEditSupplierCategory